module.exports = __webpack_public_path__ + "img/worknet.4c7020e3.jpg";